import React, { useState, useEffect, useCallback } from 'react';
import SectionTitle from '../../SectionTitle';
import OrderCard from '../../OrderCard';
import getAutomovil from '../../Queries/getAutomovil';
import Skeleton from '@mui/material/Skeleton';
import styles from './index.module.sass';
import TableModal from './TableModal';
import { useTranslation } from 'react-i18next';
import Alert from '../../Alert';

const Wheel = (props) => {
  const { device, setSessionMessage } = props;
  const { screenSize } = device;
  const { t } = useTranslation('wheel');
  const listFirsYear = [];
  const listSecondYear = [];
  /**MOBILE */
  const listFirsLine = [];
  const listSecondLine = [];
  const listExtraLine = [];
  const listExtraLine2 = [];

  const bases = [];
  const date = new Date();
  const [monthCurrent, setmonthCurrent] = useState(0);
  const [month, setmonth] = useState(date.getMonth() + 1);
  const [year, setyear] = useState(date.getFullYear());
  const [action, setaction] = useState('');
  const [option, setoption] = useState('');
  const [loading, setloading] = useState(false);
  const [mother, setmother] = useState([]);
  const [childs, setchilds] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [infoTableModal, setinfoTableModal] = useState([]);
  const [openkit, setopenkit] = useState('');
  const [nameCons, setnameCons] = useState('');
  const [alertText, setAlertText] = useState('');
  const [periodo, setperiodo] = useState('Abril');
  let kitcurrent = '';

  for (let index = 1; index <= 24; index++) {
    let showNumber = index;
    if (index <= 3) {
      bases.push(
        <div className={styles.monthNumber} id={index} key={index} onClick={() => showMonth(index)}>
          {showNumber}
        </div>,
      );
    }

    if (screenSize === 'desktop') {
      if (index > 12) {
        listSecondYear.push(
          <div
            className={`${styles.monthNumber} ${styles[screenSize]}`}
            id={index + 3}
            key={index + 3}
            onClick={() => showMonth(index + 3)}>
            {showNumber}
          </div>,
        );
      } else {
        listFirsYear.push(
          <div
            className={`${styles.monthNumber} ${styles[screenSize]}`}
            id={index + 3}
            key={index + 3}
            onClick={() => showMonth(index + 3)}>
            {showNumber}
          </div>,
        );
      }
    } else {
      if (index <= 6) {
        listFirsLine.push(
          <div
            className={`${styles.monthNumber} ${styles[screenSize]}`}
            id={index + 3}
            key={index + 3}
            onClick={() => showMonth(index + 3)}>
            &nbsp;{showNumber}
          </div>,
        );
      }
      if (index > 6 && index <= 12) {
        listSecondLine.push(
          <div
            className={`${styles.monthNumber} ${styles[screenSize]}`}
            id={index + 3}
            key={index + 3}
            onClick={() => showMonth(index + 3)}>
            {showNumber}
          </div>,
        );
      }
      if (index > 12 && index <= 18) {
        listExtraLine.push(
          <div
            className={`${styles.monthNumber} ${styles[screenSize]}`}
            id={index + 3}
            key={index + 3}
            onClick={() => showMonth(index + 3)}>
            {showNumber}
          </div>,
        );
      }
      if (index > 18) {
        listExtraLine2.push(
          <div
            className={`${styles.monthNumber} ${styles[screenSize]}`}
            id={index + 3}
            key={index + 3}
            onClick={() => showMonth(index + 3)}>
            {showNumber}
          </div>,
        );
      }
    }
  }

  function showMonth(mes) {
    if (mes > monthCurrent) {
      setOpen(true);
      setAlertText(t('alertNotFounded'));
      return;
    }
    if (monthCurrent > 0) {
      setaction('click');
      setoption('3');
      date.setMonth(date.getMonth() - (Number(monthCurrent) - Number(mes)));
      setmonth(mes);
      setyear(date.getFullYear());
      for (let index = 1; index <= 27; index++) {
        if (index === Number(mes)) {
          document.getElementById(index).className = styles.monthNumberSelect;
        } else {
          document.getElementById(index).className = styles.monthNumber;
        }
      }
      document.getElementById(monthCurrent).className = styles.monthNumberCurrent;
    } else {
      setOpen(true);
      setAlertText(t('No records'));
    }
    //showCurrentMonth();
  }

  const showCurrentMonth = useCallback(async () => {
    setloading(true);
    const response = await getAutomovil(year, month, option);
    const { Detalle = [], tipoMensaje = 'error', mensaje = '' } = response;

    if (Detalle.length > 0) {
      setperiodo(Detalle[0].TAUPERD + '-' + Detalle[0].TAUYEAR);
      let usersById = [];

      for (let index = 0; index < Detalle.length; index++) {
        usersById = Detalle.reduce((data, user) => {
          if (!data[user.TAULINE]) {
            data[user.TAULINE] = [];
          }
          data[user.TAULINE].push(user);
          return data;
        }, {});
      }

      setmother(usersById[0]);
      setchilds(usersById[1]);
      setSessionMessage(mensaje);
    }

    if (tipoMensaje === 'exito') {
      if (Detalle.length > 0) {
        setperiodo(Detalle[0].TAUPERD + '-' + Detalle[0].TAUYEAR);
        if (action !== 'click') {
          setmonthCurrent(Detalle[0].TAUMESP);
          if (monthCurrent > 0 && action === '') {
            document.getElementById(monthCurrent).className = styles.monthNumberCurrent;
          }
        }
      } else {
        setOpen(true);
        setAlertText(`${mensaje}`);
        setloading(false);
        return;
      }
      setloading(false);
    } else {
      setOpen(true);
      setAlertText(tipoMensaje);
      setloading(false);
      return;
    }
  }, [setSessionMessage, monthCurrent, year, month, action, option]);

  useEffect(() => {
    showCurrentMonth();
  }, [showCurrentMonth]);

  function showTable(object, kit, nameConsult) {
    setOpenModal(true);
    setinfoTableModal(object);
    setopenkit(kit);
    setnameCons(nameConsult);
  }

  return (
    <div className={`${styles.Validate} ${styles[screenSize]}`}>
      <SectionTitle title={t('title')} subtitle={t('subtitle')} />
      <TableModal
        open={openModal}
        setOpen={setOpenModal}
        title={nameCons}
        table={infoTableModal}
        screenSize={screenSize}
        kit={openkit}
      />

      <Alert open={open} setOpen={setOpen} title={t('titleAlert')} text={alertText} />

      <OrderCard>
        <div className={styles.iconsGold}>
          <span className={`material-icons-outlined`}>date_range</span>
        </div>
        <div className={styles.textBlue}>{t('months')}</div>
        <div className={styles.months}>{bases}</div>
        <br />
        <div className={styles.iconsGold}>
          <span className={`material-icons-outlined`}>all_inclusive</span>
        </div>
        <div className={styles.textBlue}>{t('mtto')}</div>
        <div className={styles.textGold}>
          {t('month')} {periodo}
        </div>
        {screenSize === 'desktop' ? (
          <>
            <div className={styles.months}>{listFirsYear}</div>
            <div className={styles.months}>{listSecondYear}</div>
          </>
        ) : (
          <>
            <div className={styles.months}>{listFirsLine}</div>
            <div className={styles.months}>{listSecondLine}</div>
            <div className={styles.months}>{listExtraLine}</div>
            <div className={styles.months}>{listExtraLine2}</div>
          </>
        )}
      </OrderCard>

      {(loading && (
        <>
          <Skeleton variant='rectangular' className={styles.loadingOrg} />
          <Skeleton variant='rectangular' className={styles.loadingOrg} />
        </>
      )) ||
        (mother.length > 0 && (
          <div className={styles.organigrama}>
            <ul className={styles.ul}>
              <li className={`${styles.liFirst} ${styles.li}`}>
                <div className={styles.branch}>
                  <div
                    className={styles.kitsFirst}
                    onClick={() => showTable(mother, mother[0].TAUKIT, mother[0].TAUKNOM)}>
                    {mother.length > 0 && (
                      <>
                        <div className={styles.motherName}>{mother[0].TAUKNOM}</div>
                        <div className={styles.kitsWhite}>Kit: TE{mother[0].TAUKIT}</div>
                        <div className={styles.info}>
                          {t('act')} {mother[0].TAUCPTGC}
                        </div>
                        <div className={styles.info}>
                          {t('dir')} {mother[0].TAUCDPTA}
                        </div>
                        <div className={styles.info}>
                          {t('rep')} {mother[0].TAUCDPTRA}
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div className={screenSize === 'desktop' ? styles.centrarlistas : styles.null}>
                  <ul className={styles.ul}>
                    {childs.map((val, key) => {
                      let list = '';
                      if (val.TAUKIT !== kitcurrent) {
                        list = (
                          <li
                            className={styles.li}
                            key={key}
                            onClick={() => showTable(childs, val.TAUKIT, val.TAUKNOM)}>
                            <div className={styles.subBranch}>
                              <div className={styles.name}>{val.TAUKNOM}</div>
                              <div className={styles.kits}>Kit: TE{val.TAUKIT}</div>
                              <div className={styles.info}>
                                {t('act')} <span>{val.TAUCPTGC}</span>
                              </div>
                              <div className={styles.info}>
                                {t('dir')} <span>{val.TAUCDPTA}</span>
                              </div>
                              <div className={styles.info}>
                                {t('rep')} <span>{val.TAUCDPTRA}</span>
                              </div>
                            </div>
                          </li>
                        );
                      }
                      kitcurrent = val.TAUKIT;
                      return list;
                    })}
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        ))}
    </div>
  );
};
export default Wheel;
